import { bunja } from 'bunja';
import { atom } from 'jotai';

import { mapTable } from '..';
import { Position_fromJsonValue } from '../../../model/prex.v2.r230522.tables.private_positions';
import { r230522NormalSubSocketBunja } from '../../socket';
import { SubAccountIdScope } from '../../sub-account';

export const accountPositionsBunja = bunja(() => {
  const subAccountId = bunja.use(SubAccountIdScope);
  const { subscribe, tablesAtom } = bunja.use(r230522NormalSubSocketBunja);

  const positionTableAtom = atom((get) => {
    const tables = get(tablesAtom);
    const positions = tables['private/account-positions'] || {};
    return mapTable(positions, Position_fromJsonValue);
  });

  const positionsAtom = atom((get) => {
    const positionTable = get(positionTableAtom);
    return Object.entries(positionTable)
      .sort((a, b) => b[0].localeCompare(a[0]))
      .map(([, value]) => value)
      .filter((position) => position.accountId === subAccountId);
  });

  bunja.effect(() => {
    if (subAccountId == null) return;
    return subscribe('private/account-positions', { rows: [`${subAccountId}/*`] });
  });

  return { positionsAtom };
});
accountPositionsBunja.debugLabel = 'accountPositionsBunja';
